import React, {useState, useEffect} from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import "./muiStepper.scss";
import { Col, Container, Row } from "react-bootstrap";
import apiClient from "../../common/apiClient";
import { CreateNotification } from "../notification/Notification";
import { ToCamelCase } from '../../common/common';

const MuiStepper = ({
  data,
  innerStep,
  formName,
  activeOuterStep,
  setActiveOuterStep,
  totalSteps,
  cart,
}) => {
  
  let cartTotal = (cart = []) =>
  {
    let total = 0;
    cart.forEach((item) => {
      if (item.name == "From Cast") {
        item.name = "Create Electronic Shape";
      }
      if(item.quantity > 0 && item.price > 0) {
        total += item.price * item.quantity;
      }
    });

    return total;
  }

  let cartWithIndex = Object.groupBy(cart, ({ formIndex }) => formIndex);
  if ("null" in cartWithIndex) {
    cartWithIndex = Object.groupBy(cart, ({ sourceId }) => sourceId);
  }
  const formIndexedCart = Object.values(cartWithIndex);

  let formatPrice = (price) => Number(price).toFixed(2);

  const [accountNumber, setAccountNumber] = useState(localStorage.getItem("accountNumber") ?? "");
  const [accountName, setAccountName] = useState("");

  // Fetch account name whenever accountNumber changes; cache is keyed by account number
  useEffect(() => {
    if (!accountNumber) return;

    const cachedFor = localStorage.getItem("accountNameFor");
    const cachedName = localStorage.getItem("accountName");

    if (cachedName && cachedFor === accountNumber) {
      setAccountName(cachedName);
      return;
    }

    // Cache miss or stale — clear and re-fetch
    localStorage.removeItem("accountName");
    localStorage.removeItem("accountNameFor");
    apiClient.get("accountName/" + accountNumber).then(response => {
      if (!response.data) {
        setAccountName("");
        setAccountNumber("");
        CreateNotification("Account number not found — please re-enter", "error");
        if (setActiveOuterStep) setActiveOuterStep(0);
        return;
      }
      localStorage.setItem("accountName", response.data);
      localStorage.setItem("accountNameFor", accountNumber);
      setAccountName(response.data);
    }).catch(() => {
      setAccountName("");
      CreateNotification("Could not retrieve account name — please re-enter", "error");
      if (setActiveOuterStep) setActiveOuterStep(0);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountNumber, setActiveOuterStep]);

  // When the step advances, check if accountNumber was updated in localStorage
  useEffect(() => {
    const stored = localStorage.getItem("accountNumber") ?? "";
    if (stored !== accountNumber) {
      setAccountNumber(stored);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOuterStep]);

  function isPaddingForIndex(formIndex) {
    return formIndex[0]?.serialNumber ||  formIndex[0]?.footSide ||  (formIndex[0]?.sourceId && (formName === "Liners" || formName === "Feet"))  
  }

  return (
    <div className="muiStepper leftContent" style={{ width: "100%" }}>
      <Box className="stepperWrapper">
        <Box className="muiStepper">
          <div className="formName">
            
            <p>Account: {accountName} ({accountNumber})</p>
            <br />
            <p>Order Form</p>
            <h4>{formName}</h4>
          </div>
          <div className="stepperSteps">
            <Stepper
              activeStep={activeOuterStep}
              orientation="vertical"
              className="willow-wood-stepper"
            >
              {data.map((label, index) => (
                <Step key={index}>
                  <StepLabel>{label.name}</StepLabel>
                  {activeOuterStep === index &&
                    label.innerSteps?.length > 0 && (
                      <div className="innerStepper">
                        <Stepper activeStep={innerStep} orientation="vertical">
                          {label.innerSteps.map((substep) => (
                            <Step key={`innerStep-${substep.id}`}>
                              <StepLabel className="subStep">
                                {substep.name}
                              </StepLabel>
                            </Step>
                          ))}
                        </Stepper>
                      </div>
                    )}
                </Step>
              ))}
            </Stepper>
            <div className="mobleSteps">
              <p>
                Step {`0${activeOuterStep + 1}`}/{`0${typeof totalSteps === 'function' ? totalSteps() : totalSteps}`}
              </p>
            </div>
          </div>
        </Box>
        <Box sx={{ flex: "2", padding: 2 }} className="right-content">
          <>
            <div className="stepperContent">
              {data[activeOuterStep].formContent}
            </div>
          </>
        </Box>

        {cart.length > 0 &&
          <Box sx={{ flex: "none", padding: 0 }} className="right-content">
            <Box className="stepperWrapper">
              <Box className="muiStepper">
                <Container className="formName" fluid="true" style={{ width: "200px", "paddingBottom": "90px" }}>
                  <Row><h4>Cart</h4></Row>
                  <br></br>

                  {formIndexedCart.map((formIndex, index) => {
                    return (<div key={index}>

                      {formIndex ?
                        <div className={index !== 0 && isPaddingForIndex(formIndex) ? "pt-4" : ""}>
                          {formIndex[0]?.serialNumber ?
                            <div className="row"><h4 className="mt-0">Serial Number: {formIndex[0]?.serialNumber}</h4></div> : <></>}

                          {formIndex[0]?.footSide ?
                            <div className="row"><h4 className="mt-0">Side: {formIndex[0]?.footSide}</h4></div> : <></>}

                          {formIndex[0]?.sourceId && (formName === "Liners" || formName === "Feet") ?
                            <div className="row"><h4 className="mt-0">{ToCamelCase(formIndex[0]?.sourceId)}</h4></div> : <></>}

                          {formIndex.map((item, i) => {
                            if (item.quantity > 0 && item.name) {
                              return (<Row key={i}>
                                <Col lg="6" sm="1">
                                  <Row><b>{item.name}:</b></Row>
                                  <Row><p>({item.partNumber})</p></Row>
                                </Col>
                                <Col></Col>
                                <Col>
                                  <Row>{item.quantity}x</Row>
                                  <Row><p>${formatPrice(item.price)}</p></Row>
                                </Col>
                              </Row>)
                            }
                          })}
                        </div> : <></>}
                    </div>)
                  })}

                  <br></br>
                  <Row><h4>Total: ${formatPrice(cartTotal(cart))}</h4></Row>
                </Container>
              </Box>
            </Box>
          </Box>
        }
      </Box>
    </div>
  );
};

export default MuiStepper;
